var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import InputNum from './InputNum';
// const -------------------------------------------------
export var CpErrorText = '請輸入正確的手機號碼。';
// func -------------------------------------------------
export var CellPhoneCheck = function (value) {
    return (value.length === 10 &&
        !Number.isNaN(Number(value)) &&
        value[0] === '0' &&
        value[1] === '9');
};
export var CellPhoneError = function (value) {
    return !CellPhoneCheck(value);
};
export var MultiCpCheck = function (value) {
    var errIdx = value.split(',').findIndex(function (obj) { return CellPhoneError(obj); });
    return errIdx === -1;
};
export var MultiCpError = function (value) { return !MultiCpCheck(value); };
// main -------------------------------------------------
var InputCellPhone = function (props) {
    var minLength = 10;
    var maxLength = 10;
    var _a = props.verifiers, verifiers = _a === void 0 ? [] : _a, other = __rest(props, ["verifiers"]);
    verifiers.push({ func: CellPhoneError, text: CpErrorText });
    return (React.createElement(InputNum, __assign({}, other, { minLength: minLength, maxLength: maxLength, verifiers: verifiers })));
};
export default InputCellPhone;
